import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler, applyQueryString } from 'services';
import {
  ListOrderItemInvoicesActions as Actions,
  ListOrderItemInvoicesRequestAction as RequestAction,
} from 'store/ducks/orderItemInvoices';

export function* listOrderItemInvoicesRequest(action: any) {
  const { query = {}, onSuccess, onFailure }: RequestAction = action;
  try {
    const url = applyQueryString('invoices-to-items', query);
    const { data } = yield call(api.get, url);
    onSuccess && onSuccess(data);
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
